export default function adPodsEnabled() {
  const exclude_list = ["games.gameshownetwork.com","play.dictionary.com","puzzles.independent.co.uk","puzzles.standard.co.uk","elpais.arkadiumarena.com","juegos.elpais.com","juegos.as.com","msn.testing.arkadiumarena.com","microsoft.evo.arkadiumarena.com"];
  return !exclude_list.includes(location.hostname);
}
